import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-nlmk-form',
    templateUrl: './nlmk-form.component.html',
    styleUrls: ['./nlmk-form.component.css'],
    standalone: false
})
export class NlmkFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
